import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import SetPassword from './SetPassword';

const NotFound = Loadable(lazy(() => import('./NotFound')));
const ForgotPassword = Loadable(lazy(() => import('./ForgotPassword')));
const JwtLogin = Loadable(lazy(() => import('./JwtLogin')));
const JwtRegister = Loadable(lazy(() => import('./JwtRegister')));

const sessionRoutes = [
  { path: '/session/signup', element: <JwtRegister /> },
  { path: '/session/signin', element: <JwtLogin /> },
  { path: '/session/forgot-password', element: <ForgotPassword /> },
  { path: '/session/set-password/:token', element: <SetPassword /> },
  { path: '/session/404', element: <NotFound /> },
];

export default sessionRoutes;
